import { navOption } from '../app/Interfaces/system/NavBar.interfaces';
import { Company } from '../app/Interfaces/admin/User.interfaces';
import { getSource } from './company';

export const filterOptions = (
  options: navOption[],
  selectedCompany?: Company
) => {
  const availableOptions = options.filter((opt) => {
    if (!selectedCompany) return false;
    const source = getSource(selectedCompany);
    if (!source) return false;
    if (opt.requiresActiveCompany && !selectedCompany.isActive) return false;

    return opt.companySources.includes(source);
  });

  return availableOptions;
};
